/** 가로줄이 한 번에 받는 콜랩 수. 끝까지 밀면 이만큼씩 더 붙는다 */
export const COLLAB_ROW_PAGE_SIZE = 10;
